var  $body, $modal, $secondaryModal, $window,sidebar_pos, sidebar_width,ajax_contents,scroll_from_top,menu_scroll,timeout = false,rtime,delta = 500,KEYCODE_ESC = 27;

$(function(){
	"use strict";
	 var waypoints = $('.way-point-animate').waypoint(function() {
        $(this.element).addClass('shown');
    }, {
        offset: '98%'
    });
	$('.panel-group.related-products .panel-heading a').click(function(){
		Waypoint.refreshAll()
	});	
	
	/*
	$.cookieBar({
		element: 'body',
		zindex: '999999',
		message: POLICY_TEXT,
		acceptText: ACCEPT_TEXT,
		policyText: READ_MORE,
		policyURL: POLICY_URL,
		bottom: true,
		domain: 'http://www.medicare-hellas.gr',
		referrer: 'http://www.medicare-hellas.gr'
	});
	*/
	$('.navigation-page.group_trigger').click(function(){
		if($(window).innerWidth()<767){
			if($(this).parent().hasClass('open')){
				$(this).parent().removeClass('open');
			}else{
				$('.navigation-list.open').removeClass('open');
				$(this).parent().addClass('open');
			}
			return false;	
		}		
	});

    $('[data-toggle="collapse"]').on('click',function(){
        $($(this).data('parent')).find('.panel-heading').removeClass('active');
        $(this).closest('.panel-heading').toggleClass('active');
    });
	
	if($(window).scrollTop() > 50) {
		 $("header").addClass("fixed");
	}
	var lastScrollTop = 0;
	$(document).on('scroll',function() { 
		if($(window).scrollTop() > 50) {
			 $("header").addClass("fixed");
			 $('.heros .scroll-btn').css({ opacity: 0 });	
		}else{
			$("header").removeClass("fixed");
			$('.heros .scroll-btn').css({ opacity: 1 });	
		}

		 var st = $(this).scrollTop();
		   if (st > lastScrollTop  ){
		      $('#espa').slideUp();
		   } else{
		   	 $('#espa').slideDown();
		     
		   }
		   lastScrollTop = st;
		
	});
	
	$('.medical-products-carousel').on('init', function(){
		var inpt = $('.slick-active .item ').data('img');
		$(".carousel-trigger").each(function(){
			if($(this).data('index') === inpt){
				$(".carousel-trigger").removeClass('active');
				$(this).addClass('active');
			}
		});
	});
	$('.medical-products-carousel').on('afterChange', function(){
		var inpt = $('.slick-active .item ').data('img');
		$(".carousel-trigger").each(function(){
			if($(this).data('index') === inpt){
				$(".carousel-trigger").removeClass('active');
				$(this).addClass('active');
			}
		});

	});
	callbacks();
	
});
$(document).keyup(function (e) {
	"use strict";
	if (e.keyCode === KEYCODE_ESC) {
		if ($('body').hasClass('navigation-open')) {
			$('body').css('overflow', 'auto');
			$('body').removeClass('navigation-open');
			$(".navi-trigger.cross").removeClass("cross");
		}

	}
});
var isLateralNavAnimating = false;
$(document).on('click', '.navi-trigger', function (e) {
	if (!isLateralNavAnimating) {
		$('body').toggleClass('navigation-is-open');
		$(".navi-trigger").toggleClass("cross");
	}
	e.preventDefault();
});

function equalizeHeight(target){
	"use strict";
	$('.'+ target).each(function(){
		$('.'+ target).addClass('autoHeight');
		$('.'+ target).css('min-height','auto');
		if($('.'+ target).parent().hasClass('card')){
			$('.'+ target).css('height','auto');
		}
	});
	
    var min_height = 0;
    setTimeout(function(){
        $('.'+ target).each(function(){
            if($(this).innerHeight() > min_height){
                min_height = $(this).innerHeight();
            }
        });
        if(min_height>0){
            $('.'+ target).css('min-height',min_height);
			if($('.'+ target).parent().hasClass('card')){
				$('.'+ target).css('height',min_height);
			}
        }
		$('.'+ target).each(function(){			 
			$('.'+ target).removeClass('autoHeight');
		});
		
    },500);
	
}

function initMorphsearch(){
	"use strict";
	var morphSearch = $('#morphsearch'),
		input = $('.search-button'),
		ctrlClose = $('span.morphsearch-close'),
		isOpen =  false,
		toggleSearch = function () {

			if (isOpen) {
				morphSearch.removeClass('open');
				$('body').removeClass('search-open');
				
				$('.morphsearch-content .search-results').empty();
				$('.morphsearch-input').val('');
				if (input.value !== '') {
					setTimeout(function () {
						morphSearch.addClass('hideInput');
						setTimeout(function () {
							morphSearch.removeClass('hideInput');
							input.value = '';
						}, 300);
					}, 500);
				}
				input.blur();
			}
			else {
				morphSearch.addClass('open');
				$('body').addClass('search-open');
			}
			isOpen = !isOpen;
			return false;
		};

	input.on('click', toggleSearch);
	ctrlClose.on('click', toggleSearch);

	$(document).on('keydown', function (ev) {
		var keyCode = ev.keyCode || ev.which;
		if (keyCode === 27 && isOpen) {
			toggleSearch(ev);
		}
	});	
}


function initShares(){
	"use strict";
	$('.close-share-this').click(function(){
		$('.modal.in').modal('hide');
		return false;
	});
	
	var clipboard = new Clipboard('.clipboardButton');
	clipboard.on('success', function(e) {
		console.info('Action:', e.action);
		console.info('Text:', e.text);
		console.info('Trigger:', e.trigger);
		
		$('.clipboardButton .copy-label').text(' copied!');
		
		e.clearSelection();
	});
	clipboard.on('error', function(e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
		
	});	
}
$(document).on('click', ".modal-btn", function (e) {
	"use strict";
	try{
		e.preventDefault();			
	   if($(this).attr("href")){
			openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));				
		}else{
			openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));				
		}	
	}catch(Error){
		console.log(Error);
	}
	return false;
});
function openAjaxModal(href,$mm){
	
    $m = $mm || $modal;

    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        //skinFormElements('#'+$m.attr('id'));
        callbacks('#'+$m.attr('id'));
    });
}
function more(target){
	var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
	var all_pages = Number($('form[name="'+target+'-nav"] input[name="num_pages"]').val());
	
	$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
	
	$('.more-results[rel="'+target+'"]').addClass('loading');
	$.ajax({
		data:$('form[name="'+target+'-nav"]').serialize(),
		dataType:'html',
		success:function(data){
			$newItems = $.parseHTML( data );
			$.each( $newItems, function( i, el ) {
				$(el).data('duration', i ).appendTo('#'+target+'-list');			
			});			
			if(next_page===all_pages-1){
				$('.more-results[rel="'+target+'"]').hide();
			}else{
				$('.more-results[rel="'+target+'"]').removeClass('loading');		
			}
			clickEvents();
		}
	});
}
body = document.querySelector("body");
function callbacks(c) {
    var container = c || '';
    ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
            var c = $(this).data();
            for (var i in c) {
                if (i.indexOf('fn') == 0 && c[i] != '') {
                    var fn = c[i];
                    var params = c[ 'params' + i ] || null;

                    $(this).addClass('callbacks-executed');

                    try {
                        if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                            var callbackAfter = c[ 'after' + i ];
                            var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                            window[ fn ](params, function(){
                                window[callbackAfter](callbackAfterParams);
                            });
                        } else {
                            window[ fn ](params);
                        }
                    } catch (Error) {
                        console.log(Error + ' '+fn);
                    }
                }
            }
        }
        }
    });
}

var ajax_contents = [];
function ajaxContent(c){
	"use strict";	
    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'content':$(this).data('ajaxContent'),
                'target': $(this)
            }
        );
    });
    loadAjaxContent();
}

function loadAjaxContent(){
	"use strict";
    if(ajax_contents.length > 0){
        var target = ajax_contents[0]['target'],content =  ajax_contents[0]['content'];
        if(target.hasClass('ajax-load-initiated')) {
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
            return false;
        }

        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');

            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}

